
import XDialog from 'vux/src/components/x-dialog/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
directives: {
TransferDom
},
components: {
XDialog,CheckIcon
},
data () {
return {
showmodal: false,
checkIconValue: false,
systemId:''
}
},
methods: {
handleLink () {
this.showmodal = !this.showmodal
}
},
mounted (){
var tag = window.location.search.split('=')[1]
if(tag && tag.includes('hzh')){

this.systemId = 1
}else{

this.systemId = 0
}
}
}



// WEBPACK FOOTER //
// ./src/components/Disclaimer.vue